export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '京都千年古都：探访日本传统文化的灵魂之城',
    slug: 'kyoto-traditional-culture-guide',
    excerpt: '京都是日本千年古都，承载着最深厚的传统文化底蕴。从金阁寺到伏见稻荷大社，每一处都诉说着日本的历史与美学。',
    content: `<p>京都是日本最具历史文化底蕴的城市之一，作为日本古都长达千年之久。这座城市保存了大量珍贵的文化遗产，包括17处世界文化遗产。</p>
    <h2>金阁寺：禅意与美学的完美结合</h2>
    <p>金阁寺（鹿苑寺）是京都最著名的景点之一，其金色外墙倒映在镜湖池中的景象令人叹为观止。这座建筑完美体现了日本传统美学中的"侘寂"理念——在简朴中寻找美。</p>
    <p>金阁寺最初建于1397年，作为足利义满将军的别墅。1950年被一名年轻僧侣放火烧毁，后于1955年按照原样重建。三岛由纪夫的小说《金阁寺》正是以此事件为灵感创作的。</p>
    <h2>伏见稻荷大社：千本鸟居的震撼</h2>
    <p>伏见稻荷大社以其绵延数公里的朱红色鸟居隧道闻名于世。这些鸟居由日本各地的企业和个人捐赠，每座鸟居上都刻有捐赠者的名字和捐赠日期。</p>
    <p>稻荷神是日本的农业与商业之神，狐狸被视为稻荷神的使者，因此神社内随处可见狐狸雕像。徒步穿越整座稻荷山大约需要2-3小时，沿途可以欣赏到京都城市的美景。</p>
    <h2>茶道体验：感受日本待客之道</h2>
    <p>茶道不仅仅是一种饮茶方式，更是日本传统文化的集大成者。它融合了建筑、园艺、书法、陶艺、花道等多种艺术形式，体现了"一期一会"的哲学思想——珍惜每一次相遇。</p>
    <p>在京都，许多茶室都提供面向游客的茶道体验课程，让您亲身感受这一古老传统的魅力。</p>`,
    categoryId: 'japan-culture',
    categoryName: '日本文化',
    image: 'https://readdy.ai/api/search-image?query=Kyoto%20traditional%20Japanese%20temple%20golden%20pavilion%20architecture%20in%20warm%20autumn%20lighting%2C%20reflection%20on%20calm%20pond%2C%20cream%20and%20gold%20tones%2C%20editorial%20travel%20photography%2C%20serene%20atmosphere&width=1200&height=675&seq=article-kyoto-01&orientation=landscape',
    author: '山田健一',
    date: '2026-08-10',
    readTime: '8分钟',
    tags: ['京都', '传统文化', '寺庙', '茶道'],
    featured: true
  },
  {
    id: 'article-2',
    title: '2026年必看日本电影：从是枝裕和到新海诚的视听盛宴',
    slug: 'must-watch-japanese-films-2026',
    excerpt: '日本电影以其细腻的情感表达和独特的视觉美学闻名于世。本文为您精选本年度最值得期待的日本电影作品。',
    content: `<p>日本电影产业在2026年持续蓬勃发展，从艺术电影到商业动画，呈现出多元化的创作态势。</p>
    <h2>是枝裕和新作：家庭叙事的延续</h2>
    <p>作为日本最具国际影响力的导演之一，是枝裕和以其细腻的家庭题材电影闻名。他的作品常常探讨家庭关系中的微妙情感变化，以克制的镜头语言呈现深刻的人文关怀。</p>
    <p>从《如父如子》到《小偷家族》，是枝裕和的每一部作品都在国际电影节上获得高度评价，成为日本电影走向世界的重要代表。</p>
    <h2>新海诚：视觉诗学的极致</h2>
    <p>新海诚的动画电影以极致精美的画面和感人至深的爱情故事著称。《你的名字。》《天气之子》《铃芽之旅》每一部都引发了全球观影热潮。</p>
    <p>新海诚作品中那些令人窒息的天空画面、细腻的光影处理，已经成为日本动画电影的标志性美学风格。</p>
    <h2>日本恐怖电影的复兴</h2>
    <p>日本恐怖电影（J-Horror）以其心理恐怖见长，不同于西方恐怖片的直接视觉冲击。2026年，多部新锐导演的恐怖作品在国际影展上崭露头角，预示着这一类型的强势回归。</p>`,
    categoryId: 'japan-film',
    categoryName: '日本影视',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20cinema%20theater%20interior%20with%20warm%20ambient%20lighting%20and%20red%20velvet%20seats%2C%20nostalgic%20atmosphere%2C%20cream%20and%20soft%20crimson%20tones%2C%20editorial%20photography&width=1200&height=675&seq=article-film-01&orientation=landscape',
    author: '铃木花子',
    date: '2026-08-08',
    readTime: '6分钟',
    tags: ['日本电影', '是枝裕和', '新海诚', '动画电影'],
    featured: true
  },
  {
    id: 'article-3',
    title: '东京深夜食堂：10家本地人推荐的隐秘居酒屋',
    slug: 'tokyo-hidden-izakaya-guide',
    excerpt: '远离游客聚集区的真正日本居酒屋在哪里？跟随本地美食达人的脚步，探索东京最地道的深夜美味。',
    content: `<p>东京的居酒屋文化是日本饮食文化中最具活力的部分之一。这些隐藏在巷弄深处的深夜食堂，是体验真正日本味道的最佳场所。</p>
    <h2>新宿黄金街：昭和风情的缩影</h2>
    <p>新宿黄金街保留了大量昭和时代的建筑风貌，狭窄的巷道两旁挤满了仅能容纳数人的小型居酒屋。每家店都有自己独特的招牌菜和忠实的常客群体。</p>
    <h2>惠比寿横丁：美食与文化的交汇</h2>
    <p>惠比寿横丁汇集了来自日本各地的特色料理，从北海道的海鲜到大阪的串炸，一站式体验日本各地的美食文化。这里的居酒屋大多营业至凌晨，是夜猫子的天堂。</p>
    <h2>居酒屋点餐指南</h2>
    <p>第一次去居酒屋？别担心！通常入座后会先点饮品，然后慢慢浏览菜单。推荐从"お通し"（餐前小菜）开始，再点几道"焼き鳥"（烤鸡串）和"刺身"，最后以"お茶漬け"（茶泡饭）收尾。</p>`,
    categoryId: 'japan-food',
    categoryName: '日本美食',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20izakaya%20interior%20with%20warm%20lantern%20lighting%20and%20wooden%20counter%20seating%2C%20grilled%20skewers%20on%20plate%2C%20cream%20and%20amber%20tones%2C%20editorial%20food%20photography&width=1200&height=675&seq=article-izakaya-01&orientation=landscape',
    author: '田中美食',
    date: '2026-08-05',
    readTime: '7分钟',
    tags: ['东京', '居酒屋', '美食指南', '深夜食堂'],
    featured: true
  },
  {
    id: 'article-4',
    title: '北海道四季旅行全攻略：花海、温泉与粉雪天堂',
    slug: 'hokkaido-four-seasons-travel-guide',
    excerpt: '北海道以其壮丽的自然风光和独特的美食文化吸引着全球游客。从夏季薰衣草花海到冬季粉雪胜地，四季皆有不同魅力。',
    content: `<p>北海道是日本最北端的岛屿，拥有广袤的自然景观和独特的文化魅力。每个季节都有截然不同的旅行体验。</p>
    <h2>春季：樱花与温泉的邂逅</h2>
    <p>北海道的樱花季通常比本州晚一个月左右，5月初至中旬是最佳观赏期。函馆的五棱郭公园、札幌的圆山公园都是赏樱胜地。</p>
    <h2>夏季：富良野薰衣草花海</h2>
    <p>每年7月至8月，富良野地区的薰衣草田进入最佳观赏期。紫色的花海绵延至天际，空气中弥漫着薰衣草的芳香，是北海道最具代表性的夏日风景。</p>
    <h2>冬季：二世谷粉雪胜地</h2>
    <p>北海道的粉雪质量全球闻名。二世谷（Niseko）每年吸引着来自世界各地的滑雪爱好者。轻盈干燥的粉雪让人仿佛在云中滑行，是滑雪爱好者的终极梦想。</p>`,
    categoryId: 'japan-travel',
    categoryName: '日本旅游',
    image: 'https://readdy.ai/api/search-image?query=Hokkaido%20lavender%20fields%20in%20full%20bloom%20with%20distant%20mountains%20under%20warm%20summer%20sunlight%2C%20cream%20and%20soft%20purple%20tones%2C%20editorial%20landscape%20photography&width=1200&height=675&seq=article-hokkaido-01&orientation=landscape',
    author: '佐藤旅行',
    date: '2026-08-01',
    readTime: '10分钟',
    tags: ['北海道', '旅行攻略', '温泉', '滑雪'],
    featured: true
  },
  {
    id: 'article-5',
    title: '宫崎骏动画世界：从千与千寻到你想活出怎样的人生',
    slug: 'miyazaki-animation-world-analysis',
    excerpt: '宫崎骏是日本动画的代名词，他的作品跨越世代，影响了全球数亿观众。深度解读宫崎骏动画中的哲学思考与艺术美学。',
    content: `<p>宫崎骏是日本乃至世界动画史上最具影响力的导演之一。吉卜力工作室出品的每一部动画电影都堪称艺术品。</p>
    <h2>《千与千寻》：成长与迷失的寓言</h2>
    <p>《千与千寻》是唯一获得奥斯卡最佳动画长片奖的非英语动画电影。影片通过少女千寻在神灵世界的冒险，探讨了身份认同、环境保护和资本主义批判等深刻主题。</p>
    <h2>《龙猫》：自然崇拜的纯粹表达</h2>
    <p>龙猫已经成为日本动画最具代表性的角色之一。这部电影以极其温柔的方式展现了日本传统的自然崇拜观念，让观众重拾对自然奇迹的敬畏之心。</p>
    <h2>吉卜力的手工艺术哲学</h2>
    <p>在CG动画泛滥的时代，吉卜力始终坚持手绘动画的传统。每一帧画面都由动画师一笔一画精心绘制，这种对工艺的执着本身就是一种艺术表达。</p>`,
    categoryId: 'japan-anime',
    categoryName: '日本动漫',
    image: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20inspired%20anime%20art%20style%20landscape%20with%20warm%20golden%20lighting%20and%20whimsical%20natural%20elements%2C%20cream%20and%20soft%20green%20tones%2C%20artistic%20illustration&width=1200&height=675&seq=article-ghibli-01&orientation=landscape',
    author: '高桥动画',
    date: '2026-07-28',
    readTime: '9分钟',
    tags: ['宫崎骏', '吉卜力', '动画电影', '千与千寻'],
    featured: false
  },
  {
    id: 'article-6',
    title: 'J-POP进化论：从昭和歌谣到令和偶像的日本音乐之旅',
    slug: 'jpop-evolution-music-history',
    excerpt: '日本流行音乐在过去半个世纪经历了翻天覆地的变化，从昭和时代的演歌到令和时代的虚拟偶像，J-POP一直在革新。',
    content: `<p>J-POP（日本流行音乐）是亚洲最具影响力的音乐流派之一，其发展历程反映了日本社会的变迁。</p>
    <h2>昭和歌谣时代：日本流行音乐的基石</h2>
    <p>美空云雀、山口百惠等昭和时代的歌姬奠定了日本流行音乐的基础。她们的歌曲旋律优美，歌词充满诗意，至今仍被广泛传唱。</p>
    <h2>90年代J-POP黄金期</h2>
    <p>90年代是J-POP的黄金时代，宇多田光、滨崎步、Mr.Children等艺人的崛起标志着日本音乐产业的巅峰。CD销量屡创纪录，音乐节目收视率高企。</p>
    <h2>数字时代与虚拟偶像</h2>
    <p>进入21世纪，数字音乐和流媒体平台改变了音乐消费方式。初音未来等虚拟偶像的出现更是开创了全新的音乐表现形式，展现了日本音乐产业强大的创新能力。</p>`,
    categoryId: 'japan-music',
    categoryName: '日本音乐',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20music%20recording%20studio%20with%20vintage%20vinyl%20records%20and%20modern%20equipment%2C%20warm%20ambient%20lighting%2C%20cream%20and%20soft%20amber%20tones%2C%20editorial%20photography&width=1200&height=675&seq=article-jpop-01&orientation=landscape',
    author: '松本音子',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['J-POP', '日本音乐', '偶像文化', '音乐史'],
    featured: false
  },
  {
    id: 'article-7',
    title: '原宿时尚解码：东京街头的潮流密码与穿搭哲学',
    slug: 'harajuku-fashion-decoded',
    excerpt: '原宿是全球时尚爱好者的朝圣地，这里诞生了无数独特的穿搭风格。深度解析原宿潮流文化的起源与演变。',
    content: `<p>原宿（Harajuku）是东京最著名的潮流圣地，以其大胆、多元的街头时尚文化闻名于世。</p>
    <h2>原宿风格的历史溯源</h2>
    <p>原宿潮流文化起源于1970年代，当时一群年轻人开始在表参道和竹下通进行自发的时尚展示。到了90年代，FRUiTS杂志的创办将原宿风格推向了国际舞台。</p>
    <h2>Lolita、Decora与视觉系</h2>
    <p>原宿衍生出多种独特的时尚流派：哥特洛丽塔以维多利亚风格的裙装为特色，Decora以大量彩色配饰著称，视觉系则受到摇滚音乐的影响。每种风格都有其忠实追随者。</p>
    <h2>原宿的今天：多元化与国际化</h2>
    <p>如今的原宿融合了更多国际元素，但依然保持着独特的创意精神。许多国际品牌在原宿设立旗舰店，同时本土设计师品牌也在持续创新。</p>`,
    categoryId: 'japan-fashion',
    categoryName: '日本时尚',
    image: 'https://readdy.ai/api/search-image?query=Tokyo%20Harajuku%20fashion%20street%20style%20with%20creative%20colorful%20outfits%2C%20warm%20afternoon%20sunlight%2C%20cream%20and%20soft%20pastel%20tones%2C%20editorial%20street%20photography&width=1200&height=675&seq=article-fashion-01&orientation=landscape',
    author: '青山优子',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['原宿', '潮流时尚', '穿搭', '东京'],
    featured: false
  },
  {
    id: 'article-8',
    title: '日本机器人技术前沿：从工业自动化到陪伴型AI机器人',
    slug: 'japan-robotics-frontier',
    excerpt: '日本在机器人领域一直走在世界前列，从工厂生产线到家庭陪伴，日本机器人技术正在改变我们的生活方式。',
    content: `<p>日本被称为"机器人王国"，无论是在工业制造还是服务机器人领域，都处于全球领先地位。</p>
    <h2>工业机器人的先驱</h2>
    <p>发那科（FANUC）、安川电机等日本企业在工业机器人领域拥有数十年经验。日本工厂中的工业机器人密度长期位居世界前列，是精益制造的重要支撑。</p>
    <h2>人形机器人的探索</h2>
    <p>本田的ASIMO、软银的Pepper等机器人代表了日本在人形机器人领域的前沿探索。虽然这些项目经历过起伏，但它们为机器人技术的发展提供了宝贵经验。</p>
    <h2>AI时代的日本机器人</h2>
    <p>随着AI技术的快速发展，日本机器人产业正在经历新一轮变革。将深度学习与机器人技术相结合，创造出更加智能、灵活的机器人系统，正在各个领域发挥重要作用。</p>`,
    categoryId: 'japan-tech',
    categoryName: '日本科技',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20modern%20humanoid%20robot%20in%20minimalist%20white%20laboratory%20with%20warm%20ambient%20lighting%2C%20clean%20futuristic%20aesthetic%2C%20cream%20and%20soft%20silver%20tones%2C%20editorial%20technology%20photography&width=1200&height=675&seq=article-robot-01&orientation=landscape',
    author: '中村科技',
    date: '2026-07-15',
    readTime: '8分钟',
    tags: ['机器人', 'AI', '科技前沿', '自动化'],
    featured: false
  }
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((article) => article.slug === slug);
};

export const getArticlesByCategory = (categoryId: string) => {
  return articles.filter((article) => article.categoryId === categoryId);
};

export const getFeaturedArticles = () => {
  return articles.filter((article) => article.featured);
};

export const getRelatedArticles = (article: Article, count: number = 3) => {
  return articles
    .filter((a) => a.id !== article.id && a.categoryId === article.categoryId)
    .slice(0, count);
};